import { loadable } from '@direct-frontend/modules-render';
import { DashboardTodoListFeatureHintsPendingRegistration } from '#features/DashboardTodoList';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';
import { checkIsLiteStore } from '#shared/lib/storeInfo';

const DashboardsLazy = loadable(() => import(/* webpackChunkName: "Dashboards" */ './Dashboards'));

export const DashboardsAsync = () => (
    <DelayedSuspense
        fallback={<PageStub />}
        immediateFallback={checkIsLiteStore() ? null : <DashboardTodoListFeatureHintsPendingRegistration />}
    >
        <DashboardsLazy />
    </DelayedSuspense>
);
